import { useState, useEffect, useRef } from "react"
import { useTalent } from "../contexts/talents-context"
import { motion, AnimatePresence } from "framer-motion"
import { handleTitleEdit, handleTitleSave, handleTitleCancel } from "../components/helpers/EditUtils"
import {
  X,
  Instagram,
  Star,
  Edit,
  Globe,
  Clock,
  Music,
  Calendar,
  Ruler,
  Eye,
  Palette,
  ChevronLeft,
  ChevronRight,
  Loader2,
  ImageIcon,
  Briefcase,
  Play,
} from "lucide-react"
import { toast } from "react-toastify"

export default function TalentModal({ onClose }) {
  const { selectedTalent, isModalOpen, closeModal, toggleHighlight, openEditModal, fetchTalentPhotos, fetchTalentVideosProxy, fetchPreviousJobsProxy, fetchPreviousJobById,updateTalentVideo,updateTalentPhoto } = useTalent()
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [photos, setPhotos] = useState([])
  const [videos, setVideos] = useState([])
  const [jobs, setJobs] = useState([])
  const [loadingPhotos, setLoadingPhotos] = useState(false)
  const [loadingVideos, setLoadingVideos] = useState(false)
  const [loadingJobs, setLoadingJobs] = useState(false)
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null)
  const modalRef = useRef(null)
  const photosContainerRef = useRef(null)
const [editingVideoId, setEditingVideoId] = useState(null)
const [editingTitle, setEditingTitle] = useState("")
const [editingPhotoId, setEditingPhotoId] = useState(null)
const [editingPhotoTitle, setEditingPhotoTitle] = useState("")


 


const loadPhotos = async () => {
  if (!selectedTalent?.id) return
  setLoadingPhotos(true)
  try {
    const photosData = await fetchTalentPhotos(selectedTalent.id)
    const photosArray = Array.isArray(photosData) ? photosData : []
    const validatedPhotos = photosArray.map((photo, idx) => ({
      ...photo,
      id: photo.id || `temp-id-${selectedTalent.id}-${idx}`, // Garante um ID único
      title_photo: photo.title_photo !== undefined ? photo.title_photo : `Foto ${idx + 1}`, // Fallback para título
    }))
    setPhotos(validatedPhotos)
  } catch (error) {
    console.error("Erro ao carregar fotos:", error)
    setPhotos([])
  } finally {
    setLoadingPhotos(false)
  }
}
useEffect(() => {
  console.log("useEffect disparado - isModalOpen:", isModalOpen, "selectedTalent.id:", selectedTalent?.id);
  if (isModalOpen && selectedTalent?.id) {
    console.log("Condição atendida, chamando loadPhotos, loadVideos e loadJobs");
    loadPhotos();
    loadVideos(); // Certifique-se de que esta função está chamando fetchTalentVideosProxy
    loadJobs();   // Certifique-se de que esta função está chamando fetchPreviousJobsProxy
  }
  return () => {
    setPhotos([]);
    setVideos([]);
    setJobs([]);
    setSelectedPhotoIndex(null);
  };
}, [isModalOpen, selectedTalent?.id]);

const loadVideos = async () => {
  if (!selectedTalent?.id) {
    console.log("Nenhum selectedTalent.id disponível para carregar vídeos");
    return;
  }
  console.log("Iniciando loadVideos para o talent ID:", selectedTalent.id);
  setLoadingVideos(true);
  try {
    const videosData = await fetchTalentVideosProxy(selectedTalent.id); // Use a função proxy
    console.log("Resposta de fetchTalentVideos (crua):", videosData);
    const videosArray = Array.isArray(videosData) ? videosData : [];
    console.log("Vídeos processados para renderização:", videosArray);
    setVideos(videosArray);
  } catch (error) {
    console.error("Erro ao carregar vídeos:", error);
    setVideos([]);
  } finally {
    setLoadingVideos(false);
  }
};

const loadJobs = async () => {
  if (!selectedTalent?.id) {
    console.log("Nenhum selectedTalent.id disponível para carregar jobs");
    return;
  }
  console.log("Iniciando loadJobs para o talent ID:", selectedTalent.id);
  setLoadingJobs(true);
  try {
    const jobsData = await fetchPreviousJobsProxy(selectedTalent.id); // Use a função proxy
    console.log("Resposta de fetchPreviousJobs (crua):", jobsData);
    const jobsArray = Array.isArray(jobsData) ? jobsData : [];
    const validatedJobs = jobsArray.map(job => ({
      ...job,
      job_description: job.job_description || "Trabalho sem título",
      text_format: job.text_format || "Sem descrição",
    }));
    console.log("Jobs processados para renderização:", validatedJobs);
    setJobs(validatedJobs);
  } catch (error) {
    console.error("Erro ao carregar trabalhos:", error);
    setJobs([]);
  } finally {
    setLoadingJobs(false);
  }
};



  const handleJobDetails = async (jobId) => {
    try {
      const jobDetails = await fetchPreviousJobById(jobId)
      console.log("Detalhes do trabalho:", jobDetails)
      toast.success(`Detalhes do trabalho ${jobId}: ${jobDetails.job_description}`)
    } catch (error) {
      console.error("Erro ao buscar detalhes do trabalho:", error)
      toast.error("Erro ao carregar detalhes do trabalho")
    }
  }

  // Prevenir scroll da página quando o modal estiver aberto
  useEffect(() => {
    if (isModalOpen) {
      setIsVisible(true)
      document.body.style.overflow = "hidden"
      const preventTouch = (e) => {
        if (!modalRef.current?.contains(e.target)) {
          e.preventDefault()
        }
      }
      document.addEventListener("touchmove", preventTouch, { passive: false })
      return () => {
        document.body.style.overflow = "auto"
        document.removeEventListener("touchmove", preventTouch)
      }
    }
  }, [isModalOpen])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose()
      }
    }
    if (isModalOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isModalOpen])

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        if (selectedPhotoIndex !== null) {
          setSelectedPhotoIndex(null)
        } else {
          handleClose()
        }
      }
    }
    if (isModalOpen) {
      window.addEventListener("keydown", handleEscKey)
    }
    return () => {
      window.removeEventListener("keydown", handleEscKey)
    }
  }, [isModalOpen, selectedPhotoIndex])

  if (!isModalOpen || !selectedTalent) return null

  const calculateAge = (birthDate) => {
    if (!birthDate) return "-"
    const today = new Date()
    const birth = new Date(birthDate)
    let age = today.getFullYear() - birth.getFullYear()
    const monthDiff = today.getMonth() - birth.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--
    }
    return age
  }

  const formatDate = (dateString) => {
    if (!dateString) return "-"
    try {
      const date = new Date(dateString)
      return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" })
    } catch (error) {
      return dateString
    }
  }

  const renderTalentType = (tipo_talento) => {
    if (!tipo_talento || tipo_talento.trim() === "") {
      return "A definir"
    }
    return tipo_talento
  }

  const getTalentTypeColor = (tipo_talento) => {
    if (!tipo_talento || tipo_talento.trim() === "") {
      return "bg-gray-100 text-gray-600"
    }
    if (tipo_talento === "Ator") {
      return "bg-blue-100 text-blue-800"
    }
    if (tipo_talento === "Atriz") {
      return "bg-pink-100 text-pink-800"
    }
    return "bg-purple-100 text-purple-800"
  }

  const handleToggleHighlight = async () => {
    try {
      setIsLoading(true)
      await toggleHighlight(selectedTalent.id, selectedTalent.destaque)
      selectedTalent.destaque = !selectedTalent.destaque
      toast.success(selectedTalent.destaque ? "Destaque adicionado com sucesso!" : "Destaque removido com sucesso!", {
        toastId: `toggle-highlight-${selectedTalent.id}-success`,
      })
    } catch (error) {
      console.error("Erro ao alternar destaque:", error)
      toast.error(`Erro ao alternar destaque: ${error.message}`, {
        toastId: `toggle-highlight-${selectedTalent.id}-error`,
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(() => {
      closeModal()
      if (onClose) onClose()
      setPhotos([])
      setVideos([])
      setJobs([])
      setSelectedPhotoIndex(null)
    }, 300)
  }

  const handleEdit = () => {
    const talentIdToEdit = selectedTalent.id
    setIsVisible(false)
    setTimeout(() => {
      closeModal()
      if (onClose) onClose()
      setPhotos([])
      setVideos([])
      setJobs([])
      setSelectedPhotoIndex(null)
      setTimeout(() => {
        if (typeof openEditModal === "function") {
          openEditModal(talentIdToEdit)
        } else {
          toast.error("Função de edição não disponível")
        }
      }, 50)
    }, 300)
  }

  const formatHeight = (height) => {
    if (!height) return "-"
    if (height.includes("cm")) return height
    return `${height} cm`
  }

  const formatInstagram = (instagram) => {
    if (!instagram) return null
    return instagram.startsWith("@") ? instagram : `@${instagram}`
  }

  const getStatusColor = () => {
    if (!selectedTalent.ativo) return "bg-red-500"
    return selectedTalent.disponivel ? "bg-emerald-500" : "bg-amber-500"
  }

  const getStatusText = () => {
    if (!selectedTalent.ativo) return "Inativo"
    return selectedTalent.disponivel ? "Disponível" : "Indisponível"
  }

  const handleTouchMove = (e) => {
    e.stopPropagation()
  }

  const handlePhotoClick = (index) => {
    setSelectedPhotoIndex(index)
  }

  const handleNextPhoto = () => {
    setSelectedPhotoIndex((prev) => (prev + 1) % photos.length)
  }

  const handlePrevPhoto = () => {
    setSelectedPhotoIndex((prev) => (prev - 1 + photos.length) % photos.length)
  }

  const scrollPhotos = (direction) => {
    if (photosContainerRef.current) {
      const scrollAmount = 200
      const currentScroll = photosContainerRef.current.scrollLeft
      const newScroll = direction === "left" ? currentScroll - scrollAmount : currentScroll + scrollAmount
      photosContainerRef.current.scrollTo({
        left: newScroll,
        behavior: "smooth",
      })
    }
  }

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
        >
          <motion.div
            ref={modalRef}
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: "spring", damping: 30, stiffness: 400 }}
            className="relative w-full max-w-4xl bg-white rounded-2xl overflow-hidden shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)]"
            style={{ maxHeight: "85vh" }}
            onClick={(e) => e.stopPropagation()}
            onTouchMove={handleTouchMove}
          >
            {/* Botão de fechar */}
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 z-20 flex items-center justify-center w-8 h-8 rounded-full bg-white/90 text-gray-600 hover:text-gray-900 hover:bg-white transition-all shadow-sm focus:outline-none"
              aria-label="Fechar"
            >
              <X className="h-5 w-5" />
            </button>

            {/* Container principal com scroll */}
            <div className="flex flex-col max-h-[85vh] overflow-y-auto" style={{ WebkitOverflowScrolling: "touch" }}>
              {/* Conteúdo do modal */}
              <div className="flex flex-col md:flex-row">
                {/* Coluna da foto e habilidades/idiomas */}
                <div className="w-full md:w-2/5 relative bg-gray-50">
                  <div className="relative aspect-[3/4] h-96 md:h-120 w-full">
                    <img
                      src={selectedTalent.cover || "/placeholder.svg"}
                      alt={selectedTalent.name}
                      className="w-full h-full object-cover rounded-lg"
                      onError={(e) => {
                        e.target.onerror = null
                        e.target.src = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="500" viewBox="0 0 400 500"><rect width="400" height="500" fill="%23f0f0f0"/><text x="50%" y="50%" fontFamily="Arial" fontSize="64" fill="%23d0d0d0" textAnchor="middle" dy=".3em">${selectedTalent.name?.charAt(0) || "T"}</text></svg>`
                      }}
                    />
                    {/* Status indicator */}
                    <div className="absolute top-2 left-2 flex items-center space-x-1.5 bg-white/90 p-1 rounded-full shadow-sm">
                      <div className={`h-2.5 w-2.5 rounded-full ${getStatusColor()}`}></div>
                      <span className="text-xs font-medium text-gray-900">{getStatusText()}</span>
                    </div>
                    {/* Destaque badge */}
                    {selectedTalent.destaque && (
                      <div className="absolute top-2 right-2 bg-amber-400 p-1.5 rounded-full shadow-lg">
                        <Star className="h-4 w-4 text-white fill-white" />
                      </div>
                    )}
                  </div>
                  {/* Habilidades e Idiomas abaixo da foto */}
                  <div className="p-4 flex flex-col space-y-4">
                    {/* Habilidades */}
                    <div>
                      <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium mb-3">Habilidades</h3>
                      <div className="space-y-2">
                        <div className="flex items-center p-3 bg-gray-50 rounded-lg border border-gray-100">
                          <div className="mr-3 p-1.5 bg-pink-100 rounded-full flex-shrink-0">
                            <Music className="h-4 w-4 text-pink-500" />
                          </div>
                          <div>
                            <span className="text-sm text-gray-900 font-medium">Canta</span>
                            <span className="ml-2 text-sm text-gray-500">
                              {selectedTalent.can_sing ? "Sim" : "Não"}
                            </span>
                          </div>
                        </div>
                        {selectedTalent.instruments && selectedTalent.instruments.length > 0 && (
                          <div className="flex items-start p-3 bg-gray-50 rounded-lg border border-gray-100">
                            <div className="mr-3 p-1.5 bg-pink-100 rounded-full flex-shrink-0 mt-0.5">
                              <Music className="h-4 w-4 text-pink-500" />
                            </div>
                            <div>
                              <span className="text-sm text-gray-900 font-medium">Instrumentos</span>
                              <span className="ml-2 text-sm text-gray-500 break-words">
                                {selectedTalent.instruments.join(", ")}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Idiomas */}
                    <div>
                      <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium mb-3">Idiomas</h3>
                      {selectedTalent.languages && selectedTalent.languages.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {selectedTalent.languages.map((language, index) => (
                            <div
                              key={index}
                              className="flex items-center px-3 py-1.5 bg-gray-50 rounded-full border border-gray-100"
                            >
                              <Globe className="h-3.5 w-3.5 text-gray-400 mr-1.5" />
                              <span className="text-sm text-gray-700">{language}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 text-sm text-gray-500">
                          Nenhum idioma cadastrado
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Coluna de informações */}
                <div className="w-full md:w-3/5 p-6">
                  <div className="space-y-5">
                    {/* Cabeçalho */}
                    <div className="space-y-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-900">{selectedTalent.name}</h2>
                        <div
                          className={`px-2.5 py-1 text-xs font-medium rounded-full ${getTalentTypeColor(selectedTalent.tipo_talento)}`}
                        >
                          {renderTalentType(selectedTalent.tipo_talento)}
                        </div>
                      </div>
                      <div className="flex flex-wrap items-center text-gray-500 text-sm gap-2">
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1.5 text-gray-400" />
                          <span>{calculateAge(selectedTalent.birth_date)} anos</span>
                        </div>
                        {selectedTalent.instagram && (
                          <div className="flex items-center">
                            <Instagram className="h-4 w-4 mr-1 text-pink-500" />
                            <a
                              href={`https://instagram.com/${formatInstagram(selectedTalent.instagram).replace("@", "")}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-pink-500 hover:text-pink-600 transition-colors"
                            >
                              {formatInstagram(selectedTalent.instagram)}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Disponibilidade */}
                    {!selectedTalent.disponivel && selectedTalent.data_disponibilidade && (
                      <div className="flex items-center p-3 bg-amber-50 border border-amber-100 rounded-lg text-amber-800 text-sm">
                        <Clock className="h-4 w-4 mr-2 text-amber-500 flex-shrink-0" />
                        <span>
                          Disponível a partir de: <strong>{formatDate(selectedTalent.data_disponibilidade)}</strong>
                        </span>
                      </div>
                    )}

                    {/* Características */}
                    <div>
                      <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium mb-3">
                        Características
                      </h3>
                      <div className="grid grid-cols-3 gap-2 md:gap-3">
                        <div className="flex flex-col items-center justify-center p-2 md:p-4 bg-gray-50 rounded-xl border border-gray-100">
                          <Ruler className="h-4 w-4 md:h-5 md:w-5 text-gray-400 mb-1" />
                          <span className="text-xs md:text-sm text-gray-500">Altura</span>
                          <span className="font-medium text-gray-900 text-sm md:text-base">
                            {formatHeight(selectedTalent.height)}
                          </span>
                        </div>
                        <div className="flex flex-col items-center justify-center p-2 md:p-4 bg-gray-50 rounded-xl border border-gray-100">
                          <Palette className="h-4 w-4 md:h-5 md:w-5 text-gray-400 mb-1" />
                          <span className="text-xs md:text-sm text-gray-500">Cabelos</span>
                          <span className="font-medium text-gray-900 text-sm md:text-base text-center">
                            {selectedTalent.hair_color || "-"}
                          </span>
                        </div>
                        <div className="flex flex-col items-center justify-center p-2 md:p-4 bg-gray-50 rounded-xl border border-gray-100">
                          <Eye className="h-4 w-4 md:h-5 md:w-5 text-gray-400 mb-1" />
                          <span className="text-xs md:text-sm text-gray-500">Olhos</span>
                          <span className="font-medium text-gray-900 text-sm md:text-base text-center">
                            {selectedTalent.eye_color || "-"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Carrossel de Fotos */}
              



<div>
  <div className="flex items-center justify-between mb-3">
    <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium">Fotos do Portfólio</h3>
    {photos.length > 0 && (
      <span className="text-xs text-gray-400">
        {photos.length} foto{photos.length !== 1 ? "s" : ""}
      </span>
    )}
  </div>

  {loadingPhotos ? (
    <div className="flex justify-center py-8">
      <Loader2 className="h-6 w-6 text-gray-400 animate-spin" />
    </div>
  ) : photos.length === 0 ? (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg border border-gray-100">
      <ImageIcon className="h-8 w-8 text-gray-400 mb-2" />
      <p className="text-sm text-gray-500">Nenhuma foto disponível</p>
    </div>
  ) : (
    <div className="relative">
      {photos.length >= 5 && (
        <>
          <button
            onClick={() => scrollPhotos("left")}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white/90 hover:bg-white rounded-full shadow-md flex items-center justify-center text-gray-600 hover:text-gray-900 transition-all"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button
            onClick={() => scrollPhotos("right")}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white/90 hover:bg-white rounded-full shadow-md flex items-center justify-center text-gray-600 hover:text-gray-900 transition-all"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </>
      )}
      <div
        ref={photosContainerRef}
        className="flex gap-2 overflow-x-auto scrollbar-hide pb-2"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          WebkitScrollbar: { display: "none" },
        }}
      >
        {photos.map((photo, index) => (
          // <div
          //   key={photo.id || `photo-${index}`}
          //   className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 bg-gray-100 rounded-lg overflow-hidden cursor-pointer group shadow-sm hover:shadow-md transition-all"
          //   onClick={() => handlePhotoClick(index)}
          // >
          //   <img
          //     src={photo.image_url || "/placeholder.svg"}
          //     alt={photo.title_photo || `Foto ${index + 1}`}
          //     className="w-full h-full object-cover transition-transform group-hover:scale-105"
          //     onError={(e) => {
          //       e.target.onerror = null
          //       e.target.src = "/placeholder.svg?height=100&width=100&text=Foto+não+disponível"
          //     }}
          //   />
          //   <div className="absolute inset-x-0 bottom-0 bg-black/50 text-white text-xs text-center py-1">
          //     {editingPhotoId === photo.id ? (
          //       <div className="flex items-center space-x-1 bg-white p-1 rounded-md border-2 border-pink-200 shadow-sm">
          //         <input
          //           type="text"
          //           value={editingPhotoTitle}
          //           onChange={(e) => setEditingPhotoTitle(e.target.value)}
          //           className="flex-1 px-2 py-1 border border-gray-300 rounded-md text-xs focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-gray-900 placeholder-gray-500 outline-none bg-white"
          //           placeholder="Digite o título da foto..."
          //           onKeyPress={(e) => {
          //             if (e.key === "Enter") {
          //               handleTitleSave(
          //                 photo.id,
          //                 photos,
          //                 updateTalentPhoto,
          //                 loadPhotos,
          //                 editingPhotoTitle,
          //                 setEditingPhotoId,
          //                 setEditingPhotoTitle,
          //                 "foto",
          //                 selectedTalent.id,
          //                 {
          //                   image_url: photo.image_url,
          //                   public_id: photo.public_id,
          //                   short_url: photo.short_url,
          //                 }
          //               )
          //             } else if (e.key === "Escape") {
          //               handleTitleCancel(setEditingPhotoId, setEditingPhotoTitle)
          //             }
          //           }}
          //           autoFocus
          //         />
          //         <button
          //           onClick={() =>
          //             handleTitleSave(
          //               photo.id,
          //               photos,
          //               updateTalentPhoto,
          //               loadPhotos,
          //               editingPhotoTitle,
          //               setEditingPhotoId,
          //               setEditingPhotoTitle,
          //               "foto",
          //               selectedTalent.id,
          //               {
          //                 image_url: photo.image_url,
          //                 public_id: photo.public_id,
          //                 short_url: photo.short_url,
          //               }
          //             )
          //           }
          //           className="px-2 py-1 bg-green-500 text-white rounded-md text-xs font-medium hover:bg-green-600 transition-colors shadow-sm"
          //         >
          //           ✓
          //         </button>
          //         <button
          //           onClick={() => handleTitleCancel(setEditingPhotoId, setEditingPhotoTitle)}
          //           className="px-2 py-1 bg-gray-500 text-white rounded-md text-xs font-medium hover:bg-gray-600 transition-colors shadow-sm"
          //         >
          //           ✕
          //         </button>
          //       </div>
          //     ) : (
          //       <button
          //         onClick={(e) => {
          //           e.stopPropagation() // Evita abrir a foto em tela cheia ao clicar no título
          //           handleTitleEdit(photo.id, photo.title_photo, setEditingPhotoId, setEditingPhotoTitle)
          //         }}
          //         className="text-white hover:text-pink-300 transition-colors group w-full"
          //         title="Clique para editar o título"
          //       >
          //         <span className="block truncate">
          //           {photo.title_photo || `Foto ${index + 1}`}
          //         </span>
          //         <span className="text-xs opacity-0 group-hover:opacity-100 transition-opacity">
          //           Clique para editar
          //         </span>
          //       </button>
          //     )}
          //   </div>
          // </div>


          <div
  key={photo.id || `photo-${index}`}
  className="flex-shrink-0 flex flex-col items-center"
  onClick={(e) => {
    if (!e.target.closest('button, input')) { // Evita abrir tela cheia se clicar no título ou input
      handlePhotoClick(index)
    }
  }}
>
  <div className="w-20 h-20 md:w-24 md:h-24 bg-gray-100 rounded-lg overflow-hidden cursor-pointer group shadow-sm hover:shadow-md transition-all">
    <img
      src={photo.image_url || "/placeholder.svg"}
      alt={photo.title_photo || `Foto ${index + 1}`}
      className="w-full h-full object-cover transition-transform group-hover:scale-105"
      onError={(e) => {
        e.target.onerror = null
        e.target.src = "/placeholder.svg?height=100&width=100&text=Foto+não+disponível"
      }}
    />
  </div>
  <div className="mt-1 text-xs text-gray-700 text-center w-20 md:w-24">
    {editingPhotoId === photo.id ? (
      <div className="flex flex-col space-y-1 bg-white p-1 rounded-md border-2 border-pink-200 shadow-sm">
        <input
          type="text"
          value={editingPhotoTitle}
          onChange={(e) => setEditingPhotoTitle(e.target.value)}
          className="w-full px-2 py-1 border border-gray-300 rounded-md text-xs focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-gray-900 placeholder-gray-500 outline-none bg-white"
          placeholder="Título da foto..."
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleTitleSave(
                photo.id,
                photos,
                updateTalentPhoto,
                loadPhotos,
                editingPhotoTitle,
                setEditingPhotoId,
                setEditingPhotoTitle,
                "foto",
                selectedTalent.id,
                {
                  image_url: photo.image_url,
                  public_id: photo.public_id,
                  short_url: photo.short_url,
                }
              )
            } else if (e.key === "Escape") {
              handleTitleCancel(setEditingPhotoId, setEditingPhotoTitle)
            }
          }}
          autoFocus
        />
        <div className="flex justify-between">
          <button
            onClick={() => handleTitleSave(
              photo.id,
              photos,
              updateTalentPhoto,
              loadPhotos,
              editingPhotoTitle,
              setEditingPhotoId,
              setEditingPhotoTitle,
              "foto",
              selectedTalent.id,
              {
                image_url: photo.image_url,
                public_id: photo.public_id,
                short_url: photo.short_url,
              }
            )}
            className="px-2 py-1 bg-green-500 text-white rounded-md text-xs font-medium hover:bg-green-600 transition-colors shadow-sm"
          >
            ✓
          </button>
          <button
            onClick={() => handleTitleCancel(setEditingPhotoId, setEditingPhotoTitle)}
            className="px-2 py-1 bg-gray-500 text-white rounded-md text-xs font-medium hover:bg-gray-600 transition-colors shadow-sm"
          >
            ✕
          </button>
        </div>
      </div>
    ) : (
      <button
        onClick={(e) => {
          e.stopPropagation()
          handleTitleEdit(photo.id, photo.title_photo, setEditingPhotoId, setEditingPhotoTitle)
        }}
        className="hover:text-pink-600 transition-colors group w-full"
        title="Clique para editar o título"
      >
        <span className="block truncate">
          {photo.title_photo || `Foto ${index + 1}`}
        </span>
        <span className="text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity">
          Clique para editar
        </span>
      </button>
    )}
  </div>
</div>
        ))}
      </div>
    </div>
  )}
</div>
                    {/* Seção de Vídeos */}

{/* <div>
  <div className="flex items-center justify-between mb-3">
    <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium">Vídeos do Portfólio</h3>
    {videos.length > 0 && (
      <span className="text-xs text-gray-400">
        {videos.length} vídeo{videos.length !== 1 ? "s" : ""}
      </span>
    )}
  </div>

  {loadingVideos ? (
    <div className="flex justify-center py-8">
      <Loader2 className="h-6 w-6 text-gray-400 animate-spin" />
    </div>
  ) : videos.length === 0 ? (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg border border-gray-100">
      <ImageIcon className="h-8 w-8 text-gray-400 mb-2" />
      <p className="text-sm text-gray-500">Nenhum vídeo disponível</p>
    </div>
  ) : (
    <div className="space-y-3">
      {videos.filter(video => video && video.id != null).map((video, index) => (
        <div
          key={video.id ? `video-${video.id}` : `video-fallback-${index}`}
          className="flex items-center p-3 bg-gray-50 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all relative"
        >
          <video
            id={`video-${video.id ? video.id : index}`}
            className="w-24 h-16 md:w-32 md:h-20 object-cover rounded-md mr-3"
            controls
          >
            <source src={video.video_url || "/placeholder-video.mp4"} type="video/mp4" />
            Seu navegador não suporta a reprodução de vídeo.
          </video>
          <div className="flex-1">
            {editingVideoId === video.id ? (
              <div className="flex items-center space-x-2 bg-white p-2 rounded-lg border-2 border-pink-200 shadow-sm">
                <input
                  type="text"
                  value={editingTitle}
                  onChange={(e) => setEditingTitle(e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-gray-900 placeholder-gray-500 outline-none bg-white"
                  placeholder="Digite o título do vídeo..."
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleTitleSave(video.id)
                    } else if (e.key === "Escape") {
                      handleTitleCancel()
                    }
                  }}
                  autoFocus
                />
                <button
                  onClick={() => handleTitleSave(video.id)}
                  className="px-3 py-2 bg-green-500 text-white rounded-md text-xs font-medium hover:bg-green-600 transition-colors shadow-sm"
                >
                  ✓ Salvar
                </button>
                <button
                  onClick={handleTitleCancel}
                  className="px-3 py-2 bg-gray-500 text-white rounded-md text-xs font-medium hover:bg-gray-600 transition-colors shadow-sm"
                >
                  ✕ Cancelar
                </button>
              </div>
            ) : (
              <button
                onClick={() => handleTitleEdit(video.id, video.title_video)}
                className="text-left hover:text-pink-600 transition-colors group"
                title="Clique para editar o título"
              >
                <div className="flex items-center">
                  <h4 className="text-sm font-medium text-gray-900 group-hover:underline">
                    {video.title_video || `Vídeo ${index + 1}`}
                  </h4>
                  {video.video_in_exposicao && (
                    <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                      <Star className="h-3 w-3 mr-1 text-amber-500" />
                      Em exposição
                    </span>
                  )}
                </div>
                <span className="text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity">
                  Clique para editar
                </span>
              </button>
            )}
            <p className="text-xs text-gray-500 mt-1">
              {video.description || "Sem descrição"}
            </p>
          </div>
          <button
            onClick={() => {
              const videoElement = document.getElementById(`video-${video.id ? video.id : index}`)
              if (videoElement) videoElement.play()
            }}
            className="ml-3 p-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full transition-colors shadow-sm"
            aria-label="Reproduzir vídeo"
          >
            <Play className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )}
</div> */}


<div>
  <div className="flex items-center justify-between mb-3">
    <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium">Vídeos do Portfólio</h3>
    {videos.length > 0 && (
      <span className="text-xs text-gray-400">
        {videos.length} vídeo{videos.length !== 1 ? "s" : ""}
      </span>
    )}
  </div>

  {loadingVideos ? (
    <div className="flex justify-center py-8">
      <Loader2 className="h-6 w-6 text-gray-400 animate-spin" />
    </div>
  ) : videos.length === 0 ? (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg border border-gray-100">
      <ImageIcon className="h-8 w-8 text-gray-400 mb-2" />
      <p className="text-sm text-gray-500">Nenhum vídeo disponível</p>
    </div>
  ) : (
    <div className="space-y-3">
      {videos
        .filter((video) => video && video.id != null)
        .map((video, index) => (
          <div
            key={video.id} // Usa ID único
            className="flex items-center p-3 bg-gray-50 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all relative"
          >
            <video
              id={`video-${video.id}`}
              className="w-24 h-16 md:w-32 md:h-20 object-cover rounded-md mr-3"
              controls
            >
              <source src={video.video_url || "/placeholder-video.mp4"} type="video/mp4" />
              Seu navegador não suporta a reprodução de vídeo.
            </video>
            <div className="flex-1">
              {editingVideoId === video.id ? (
                <div className="flex items-center space-x-2 bg-white p-2 rounded-lg border-2 border-pink-200 shadow-sm">
                  <input
                    type="text"
                    value={editingTitle}
                    onChange={(e) => setEditingTitle(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-gray-900 placeholder-gray-500 outline-none bg-white"
                    placeholder="Digite o título do vídeo..."
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleTitleSave(
                          video.id,
                          videos,
                          updateTalentVideo,
                          loadVideos,
                          editingTitle,
                          setEditingVideoId,
                          setEditingTitle,
                          "vídeo",
                          selectedTalent.id,
                          {
                            video_url: video.video_url,
                            public_id: video.public_id,
                            short_url: video.short_url,
                            video_in_exposicao: video.video_in_exposicao,
                          }
                        )
                      } else if (e.key === "Escape") {
                        handleTitleCancel(setEditingVideoId, setEditingTitle)
                      }
                    }}
                    autoFocus
                  />
                  <button
                    onClick={() =>
                      handleTitleSave(
                        video.id,
                        videos,
                        updateTalentVideo,
                        loadVideos,
                        editingTitle,
                        setEditingVideoId,
                        setEditingTitle,
                        "vídeo",
                        selectedTalent.id,
                        {
                          video_url: video.video_url,
                          public_id: video.public_id,
                          short_url: video.short_url,
                          video_in_exposicao: video.video_in_exposicao,
                        }
                      )
                    }
                    className="px-3 py-2 bg-green-500 text-white rounded-md text-xs font-medium hover:bg-green-600 transition-colors shadow-sm"
                  >
                    ✓ Salvar
                  </button>
                  <button
                    onClick={() => handleTitleCancel(setEditingVideoId, setEditingTitle)}
                    className="px-3 py-2 bg-gray-500 text-white rounded-md text-xs font-medium hover:bg-gray-600 transition-colors shadow-sm"
                  >
                    ✕ Cancelar
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => handleTitleEdit(video.id, video.title_video, setEditingVideoId, setEditingTitle)}
                  className="text-left hover:text-pink-600 transition-colors group"
                  title="Clique para editar o título"
                >
                  <div className="flex items-center">
                    <h4 className="text-sm font-medium text-gray-900 group-hover:underline">
                      {video.title_video || `Vídeo ${index + 1}`}
                    </h4>
                    {video.video_in_exposicao && (
                      <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                        <Star className="h-3 w-3 mr-1 text-amber-500" />
                        Em exposição
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity">
                    Clique para editar
                  </span>
                </button>
              )}
              <p className="text-xs text-gray-500 mt-1">
                {video.description || "Sem descrição"}
              </p>
            </div>
            <button
              onClick={() => {
                const videoElement = document.getElementById(`video-${video.id}`)
                if (videoElement) videoElement.play()
              }}
              className="ml-3 p-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full transition-colors shadow-sm"
              aria-label="Reproduzir vídeo"
            >
              <Play className="h-4 w-4" />
            </button>
          </div>
        ))}
    </div>
  )}
</div>



                    {/* Trabalhos Anteriores */}
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <h3 className="text-sm uppercase tracking-wider text-gray-500 font-medium">
                          Trabalhos Anteriores
                        </h3>
                        {jobs.length > 0 && (
                          <span className="text-xs text-gray-400">
                            {jobs.length} trabalho{jobs.length !== 1 ? "s" : ""}
                          </span>
                        )}
                      </div>
                      {loadingJobs ? (
                        <div className="flex justify-center py-8">
                          <Loader2 className="h-6 w-6 text-gray-400 animate-spin" />
                        </div>
                      ) : jobs.length === 0 ? (
                        <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg border border-gray-100">
                          <Briefcase className="h-8 w-8 text-gray-400 mb-2" />
                          <p className="text-sm text-gray-500">Nenhum trabalho cadastrado</p>
                        </div>
                      ) : (
                        <div className="space-y-3">
                          {jobs.filter(job => job && job.id != null).map((job, index) => (
  <div
    key={job.id ? `job-${job.id}-${selectedTalent.id}` : `job-fallback-${index}-${selectedTalent.id}`}
    className="flex items-start p-3 bg-gray-50 rounded-lg border border-gray-100"
  >
    <div className="mr-3 p-1.5 bg-purple-100 rounded-full flex-shrink-0">
      <Briefcase className="h-4 w-4 text-purple-500" />
    </div>
    <div className="flex-grow">
      <h4 className="text-sm font-medium text-gray-900">
        {job.job_description || "Trabalho sem título"}
      </h4>
      <p className="text-xs text-gray-500 mt-1">
        {job.text_format || "Sem descrição"}
      </p>
      {job.id && (
        <button
          onClick={() => handleJobDetails(job.id)}
          className="mt-1 text-xs text-blue-500 hover:text-blue-600"
          aria-label={`Ver detalhes do trabalho ${job.id}`}
        >
          Ver detalhes
        </button>
      )}
    </div>
  </div>
))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Barra de ações fixa na parte inferior */}
              <div className="p-4 border-t border-gray-100 bg-white mt-auto">
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={handleEdit}
                    className="flex-1 flex items-center justify-center py-3 sm:h-11 bg-gray-900 hover:bg-black text-white rounded-lg transition-colors shadow-sm"
                    type="button"
                  >
                    <Edit className="h-4 w-4 mr-2" />
                    Editar Perfil
                  </button>
                  <button
                    onClick={handleToggleHighlight}
                    disabled={isLoading}
                    className={`flex-1 flex items-center justify-center py-3 sm:h-11 rounded-lg transition-colors shadow-sm ${
                      selectedTalent.destaque
                        ? "bg-amber-500 hover:bg-amber-600 text-white"
                        : "bg-white hover:bg-gray-50 text-gray-900 border border-gray-200"
                    }`}
                    type="button"
                  >
                    {isLoading ? (
                      <Loader2 className="h-5 w-5 animate-spin" />
                    ) : (
                      <>
                        <Star className={`h-4 w-4 mr-2 ${selectedTalent.destaque ? "fill-white" : ""}`} />
                        {selectedTalent.destaque ? "Remover Destaque" : "Destacar Talento"}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}

      {/* Modal de visualização de foto em tela cheia */}
      <AnimatePresence>
        {selectedPhotoIndex !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedPhotoIndex(null)}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="relative max-w-4xl max-h-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={photos[selectedPhotoIndex]?.image_url || "/placeholder.svg"}
                alt={`Foto ${selectedPhotoIndex + 1} de ${selectedTalent.name}`}
                className="max-w-full max-h-full object-contain rounded-lg"
              />

              {photos.length > 1 && (
                <>
                  <button
                    onClick={handlePrevPhoto}
                    className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-colors"
                  >
                    <ChevronLeft className="h-5 w-5" />
                  </button>
                  <button
                    onClick={handleNextPhoto}
                    className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-colors"
                  >
                    <ChevronRight className="h-5 w-5" />
                  </button>
                </>
              )}

              <button
                onClick={() => setSelectedPhotoIndex(null)}
                className="absolute top-4 right-4 w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-colors"
              >
                <X className="h-5 w-5" />
              </button>

              {photos.length > 1 && (
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
                  {selectedPhotoIndex + 1} de {photos.length}
                </div>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </AnimatePresence>
  )
}





